/* eslint-disable no-console */
import { onError } from 'apollo-link-error';

const logout = () => {
  localStorage.removeItem('userInventoryToken');
  localStorage.removeItem('userInventory');
  window.location.reload();
};

const errorHandler = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    // eslint-disable-next-line array-callback-return
    graphQLErrors.map(({ message, locations, path }) => {
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);

      if (message && message.includes('Invalid token')) {
        logout();
      }
    });
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export default errorHandler;
